var _rect, _path, _rect2, _mask, _path2, _path3, _rect3, _path4, _path5, _circle, _rect4, _rect5, _rect6, _path6, _rect7, _path7, _circle2, _circle3, _circle4, _rect8, _rect9, _rect0, _rect1, _path8, _rect10, _path9, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path0, _rect25, _path1, _path10, _path11, _path12, _path13, _rect26, _rect27, _rect28, _rect29, _rect30, _path14, _path15, _rect31, _rect32, _path16, _path17, _path18, _path19, _circle5, _circle6, _circle7, _circle8, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect33, _rect34, _circle9, _circle0, _rect35, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _rect36, _path109, _path110, _path111, _path112, _path113, _path114, _rect37, _path115, _path116, _path117, _path118, _path119, _path120, _rect38, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 509,
    viewBox: "0 0 483 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.446347,
    y: -0.497113,
    width: 317.523,
    height: 207.184,
    rx: 10.5,
    transform: "matrix(1 0 -0.107305 0.994226 22.2344 18.9971)",
    fill: "white",
    stroke: "#B5DBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4264 44.0008H336.112L317.77 213.951C317.177 219.442 312.22 223.893 306.697 223.893H10.0109C4.48807 223.893 0.491333 219.442 1.08396 213.951L19.4264 44.0008Z",
    fill: "#DDEDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.446347,
    y: -0.497113,
    width: 252.17,
    height: 167.137,
    rx: 6.5,
    transform: "matrix(1 0 -0.107305 0.994226 78.2791 51.3551)",
    fill: "white",
    stroke: "#B5DBFF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_7316_186954",
    maskUnits: "userSpaceOnUse",
    x: 157.886,
    y: 120.687,
    width: 61.863,
    height: 35.7921,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 157.886,
    y: 120.687,
    width: 61.863,
    height: 35.7921
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.642 121.682C165.328 121.682 162.353 124.352 161.998 127.647L160.238 143.949C159.883 147.244 162.281 149.915 165.595 149.915H181.333L185.903 155.005C186.252 155.393 186.885 155.393 187.318 155.005L192.987 149.915H208.726C212.04 149.915 215.015 147.244 215.37 143.949L217.13 127.647C217.485 124.352 215.087 121.682 211.773 121.682H168.642Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.642 121.682C165.328 121.682 162.353 124.352 161.998 127.647L160.238 143.949C159.883 147.244 162.281 149.915 165.595 149.915H181.333L185.903 155.005C186.252 155.393 186.885 155.393 187.318 155.005L192.987 149.915H208.726C212.04 149.915 215.015 147.244 215.37 143.949L217.13 127.647C217.485 124.352 215.087 121.682 211.773 121.682H168.642Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.333 149.915L182.116 149.211L181.855 148.92H181.441L181.333 149.915ZM185.903 155.005L186.686 154.302L186.686 154.302L185.903 155.005ZM192.987 149.915L193.094 148.92H192.68L192.355 149.211L192.987 149.915ZM215.37 143.949H216.37H215.37ZM217.13 127.647L216.13 127.647L217.13 127.647ZM162.998 127.647C163.294 124.901 165.773 122.676 168.534 122.676L168.749 120.687C164.883 120.687 161.413 123.803 160.998 127.647H162.998ZM161.238 143.949L162.998 127.647H160.998L159.238 143.949H161.238ZM165.702 148.92C162.94 148.92 160.942 146.695 161.238 143.949H159.238C158.824 147.793 161.621 150.909 165.487 150.909L165.702 148.92ZM181.441 148.92H165.702L165.487 150.909H181.226L181.441 148.92ZM186.686 154.302L182.116 149.211L180.55 150.618L185.121 155.708L186.686 154.302ZM186.686 154.302L186.686 154.302L185.121 155.708C185.818 156.484 187.084 156.484 187.949 155.708L186.686 154.302ZM192.355 149.211L186.686 154.302L187.949 155.708L193.618 150.618L192.355 149.211ZM208.834 148.92H193.094L192.879 150.909H208.619L208.834 148.92ZM214.37 143.949C214.074 146.695 211.595 148.92 208.834 148.92L208.619 150.909C212.485 150.909 215.955 147.793 216.37 143.949H214.37ZM216.13 127.647L214.37 143.949H216.37L218.13 127.647L216.13 127.647ZM211.666 122.676C214.428 122.676 216.426 124.901 216.13 127.647H218.13C218.544 123.803 215.747 120.687 211.881 120.687L211.666 122.676ZM168.534 122.676H211.666L211.881 120.687H168.749L168.534 122.676Z",
    fill: "#B5DBFF",
    mask: "url(#path-4-outside-1_7316_186954)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 41.1078,
    height: 5.47054,
    rx: 2.73527,
    transform: "matrix(1 0 -0.107305 0.994226 168.866 128.979)",
    fill: "#B5DBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.469 168.706L159.992 159.72C155.217 158.099 149.885 158.057 144.743 159.6L133.684 162.917C130.882 163.758 128.196 165.051 125.74 166.742L113.564 175.124L110.827 200.476C110.59 202.673 112.189 204.453 114.398 204.453H298.364C300.573 204.453 302.556 202.673 302.793 200.476L308.855 144.303L300.01 151.434C289.649 159.788 275.366 159.606 267.051 151.015C260.47 144.215 249.038 144.385 241.174 151.399L229.529 161.784C223.519 167.144 215.85 170.153 208.197 170.153H195.384C192.302 170.153 189.293 169.664 186.469 168.706Z",
    fill: "#DDEDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.564 175.124L118.07 170.892C125.679 163.747 135.353 159.281 145.33 158.309V158.309C151.251 157.731 157.094 158.404 162.468 160.281L183.216 167.527C188.193 169.266 193.513 170.153 198.966 170.153H201.536C213.456 170.153 225.399 165.467 234.76 157.119L239.011 153.327C248.083 145.237 261.27 145.041 268.861 152.885V152.885C276.151 160.416 288.671 160.575 297.755 153.252L308.855 144.303",
    stroke: "#B5DBFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.30674,
    cy: 6.30674,
    r: 5.30674,
    transform: "matrix(1 0 -0.107305 0.994226 179.603 161.51)",
    fill: "#B5DBFF",
    stroke: "white",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.553653,
    y: -0.497113,
    width: 14.166,
    height: 14.166,
    rx: 7.08299,
    transform: "matrix(-1 0 -0.107305 0.994226 328.055 23.8173)",
    fill: "white",
    stroke: "#B5DBFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 136.094,
    height: 10.6686,
    rx: 3,
    transform: "matrix(1 0 -0.107305 0.994226 118.092 25.0615)",
    fill: "#DDEDFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.446347,
    y: -0.497113,
    width: 14.166,
    height: 14.166,
    rx: 3.5,
    transform: "matrix(1 0 -0.107305 0.994226 78.4525 23.8173)",
    fill: "white",
    stroke: "#B5DBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2981 26.4963L82.3167 30.0711L85.5265 33.6458",
    stroke: "#B5DBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.553653,
    y: -0.497113,
    width: 14.166,
    height: 14.166,
    rx: 3.5,
    transform: "matrix(-1 0 -0.107305 0.994226 111.111 23.8173)",
    fill: "white",
    stroke: "#B5DBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.687 26.4963L104.896 30.0711L100.915 33.6458",
    stroke: "#B5DBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.09728,
    cy: 4.09728,
    r: 4.09728,
    transform: "matrix(1 0 -0.107305 0.994226 30.6486 26.4963)",
    fill: "#E55A9E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.09728,
    cy: 4.09728,
    r: 4.09728,
    transform: "matrix(1 0 -0.107305 0.994226 41.8781 26.4963)",
    fill: "#F4D179"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.09728,
    cy: 4.09728,
    r: 4.09728,
    transform: "matrix(1 0 -0.107305 0.994226 53.1085 26.4963)",
    fill: "#B2CC6C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 139.467,
    height: 48.3538,
    rx: 6,
    transform: "matrix(1 0 -0.107305 0.994226 86.9219 60.1846)",
    fill: "#DDEDFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.5606,
    height: 13.8129,
    transform: "matrix(1 0 -0.107305 0.994226 97.326 80.779)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 11.5606,
    height: 24.6393,
    transform: "matrix(1 0 -0.107305 0.994226 114.725 70.0149)",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 11.5606,
    height: 19.2672,
    transform: "matrix(1 0 -0.107305 0.994226 130.386 75.3559)",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.401 76.9126L165.848 92.8281H162.199L170.759 77.3214H161.972L162.303 74.2558H174.687L174.401 76.9126ZM183.746 78.8542C183.652 78.1389 183.41 77.6024 183.02 77.2448C182.648 76.8871 182.067 76.7083 181.279 76.7083C180.097 76.7083 179.172 77.1851 178.504 78.1389C177.855 79.0756 177.407 80.6084 177.16 82.7372C177.645 82.056 178.301 81.528 179.129 81.1534C179.96 80.7616 180.837 80.5658 181.762 80.5658C182.876 80.5658 183.835 80.8042 184.64 81.2811C185.445 81.758 186.038 82.4562 186.418 83.3759C186.8 84.2785 186.923 85.3685 186.785 86.6458C186.654 87.855 186.289 88.9365 185.689 89.8902C185.109 90.8269 184.319 91.5593 183.32 92.0872C182.321 92.6152 181.17 92.8792 179.868 92.8792C178.087 92.8792 176.724 92.4875 175.781 91.704C174.855 90.9206 174.262 89.8306 174.001 88.4341C173.76 87.0205 173.75 85.2834 173.973 83.2226C174.309 80.106 175.102 77.7557 176.353 76.1718C177.604 74.5709 179.395 73.7704 181.725 73.7704C183.524 73.7704 184.867 74.2558 185.756 75.2266C186.645 76.1973 187.088 77.4065 187.086 78.8542H183.746ZM180.623 83.5036C179.715 83.5036 178.924 83.7676 178.251 84.2956C177.577 84.8235 177.186 85.5899 177.078 86.5947C176.969 87.5996 177.166 88.3915 177.669 88.9706C178.189 89.5496 178.971 89.8391 180.016 89.8391C180.941 89.8391 181.7 89.5581 182.291 88.9961C182.9 88.4341 183.256 87.6762 183.359 86.7225C183.466 85.7347 183.285 84.9513 182.816 84.3722C182.365 83.7932 181.634 83.5036 180.623 83.5036ZM191.563 78.7775C191.703 77.4832 192.189 76.4698 193.022 75.7375C193.872 75.0052 194.896 74.639 196.096 74.639C197.295 74.639 198.232 75.0052 198.906 75.7375C199.598 76.4698 199.874 77.4832 199.734 78.7775C199.593 80.0889 199.097 81.1108 198.247 81.8431C197.415 82.5754 196.399 82.9416 195.199 82.9416C194 82.9416 193.055 82.5754 192.363 81.8431C191.688 81.1108 191.422 80.0889 191.563 78.7775ZM208.473 74.9456L196.445 92.8281H192.95L204.953 74.9456H208.473ZM195.838 76.7849C194.896 76.7849 194.353 77.4491 194.21 78.7775C194.065 80.123 194.463 80.7957 195.405 80.7957C195.868 80.7957 196.245 80.6339 196.537 80.3103C196.831 79.9697 197.014 79.4588 197.088 78.7775C197.231 77.4491 196.815 76.7849 195.838 76.7849ZM201.743 88.9706C201.885 87.6592 202.371 86.6458 203.202 85.9305C204.052 85.1982 205.076 84.832 206.275 84.832C207.475 84.832 208.403 85.1982 209.06 85.9305C209.737 86.6458 210.004 87.6592 209.863 88.9706C209.721 90.2819 209.234 91.3038 208.401 92.0361C207.586 92.7685 206.578 93.1346 205.379 93.1346C204.163 93.1346 203.218 92.7685 202.543 92.0361C201.868 91.3038 201.602 90.2819 201.743 88.9706ZM206.018 86.9779C205.042 86.9779 204.482 87.6421 204.339 88.9706C204.193 90.316 204.609 90.9887 205.585 90.9887C206.545 90.9887 207.097 90.316 207.242 88.9706C207.385 87.6421 206.977 86.9779 206.018 86.9779Z",
    fill: "#85BAF1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 85.8489,
    height: 48.3538,
    rx: 6,
    transform: "matrix(1 0 -0.107305 0.994226 233.77 60.1849)",
    fill: "#DDEDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M263.559 88.3895C264.97 86.1299 265.613 83.5448 265.385 81.0535C265.157 78.5622 264.071 76.3108 262.304 74.6645C260.536 73.0183 258.191 72.0737 255.647 71.984C253.104 71.8944 250.512 72.6649 248.293 74.1706C246.073 75.6763 244.355 77.8288 243.419 80.2791C242.482 82.7293 242.381 85.3335 243.132 87.6693C243.883 90.0051 245.442 91.9354 247.556 93.1471C249.671 94.3588 252.216 94.7809 254.78 94.3448L254.409 88.8471C253.115 89.0672 251.831 88.8542 250.764 88.2426C249.696 87.631 248.91 86.6567 248.53 85.4778C248.151 84.2989 248.202 82.9845 248.675 81.7478C249.148 80.5111 250.015 79.4247 251.135 78.6647C252.256 77.9048 253.564 77.5159 254.847 77.5611C256.131 77.6064 257.315 78.0831 258.207 78.914C259.099 79.7449 259.647 80.8813 259.762 82.1387C259.877 83.3961 259.552 84.7009 258.841 85.8413L263.559 88.3895Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 36.4043,
    height: 6.05479,
    rx: 3.0274,
    transform: "matrix(1 0 -0.107305 0.994226 29.626 60.1849)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 32.0779,
    height: 3.31599,
    rx: 1.658,
    transform: "matrix(1 0 -0.107305 0.994226 28.135 73.9994)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 23.6068,
    height: 3.31599,
    rx: 1.658,
    transform: "matrix(1 0 -0.107305 0.994226 27.0281 84.2558)",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 28.0412,
    height: 3.31599,
    rx: 1.658,
    transform: "matrix(1 0 -0.107305 0.994226 25.9211 94.5121)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 19.4901,
    height: 3.31599,
    rx: 1.658,
    transform: "matrix(1 0 -0.107305 0.994226 24.8142 104.769)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 32.0779,
    height: 3.31599,
    rx: 1.658,
    transform: "matrix(1 0 -0.107305 0.994226 23.7072 115.025)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 28.0412,
    height: 3.31599,
    rx: 1.658,
    transform: "matrix(1 0 -0.107305 0.994226 22.6002 125.281)",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 32.0779,
    height: 3.31599,
    rx: 1.658,
    transform: "matrix(1 0 -0.107305 0.994226 21.4933 135.538)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 27.0889,
    height: 6.05479,
    rx: 3.0274,
    transform: "matrix(1 0 -0.107305 0.994226 80.89 123.717)",
    fill: "#DDEDFF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 27.0889,
    height: 6.05479,
    rx: 3.0274,
    transform: "matrix(1 0 -0.107305 0.994226 79.2958 138.489)",
    fill: "#DDEDFF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 27.0889,
    height: 6.05479,
    rx: 3.0274,
    transform: "matrix(1 0 -0.107305 0.994226 77.7015 153.26)",
    fill: "#DDEDFF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 27.0889,
    height: 6.05479,
    rx: 3.0274,
    transform: "matrix(1 0 -0.107305 0.994226 76.1073 168.031)",
    fill: "#DDEDFF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 27.0889,
    height: 6.05479,
    rx: 3.0274,
    transform: "matrix(1 0 -0.107305 0.994226 74.5131 182.802)",
    fill: "#DDEDFF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 27.0889,
    height: 6.05479,
    rx: 3.0274,
    transform: "matrix(1 0 -0.107305 0.994226 72.9188 197.573)",
    fill: "#DDEDFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M282.418 82.9672C280.801 82.0815 280.092 80.7106 280.293 78.8542C280.392 77.9345 280.713 77.1 281.257 76.3506C281.819 75.5842 282.595 74.9796 283.585 74.5368C284.594 74.077 285.784 73.8471 287.154 73.8471C288.525 73.8471 289.656 74.077 290.548 74.5368C291.46 74.9796 292.106 75.5842 292.485 76.3506C292.884 77.1 293.034 77.9345 292.935 78.8542C292.834 79.7909 292.513 80.6169 291.973 81.3322C291.436 82.0304 290.76 82.5754 289.947 82.9672C290.845 83.3759 291.517 83.972 291.964 84.7554C292.41 85.5388 292.576 86.467 292.46 87.54C292.335 88.6981 291.926 89.7114 291.232 90.58C290.558 91.4315 289.682 92.0872 288.605 92.5471C287.527 93.0069 286.346 93.2368 285.061 93.2368C283.777 93.2368 282.645 93.0069 281.667 92.5471C280.706 92.0872 279.972 91.4315 279.464 90.58C278.975 89.7114 278.794 88.6981 278.919 87.54C279.034 86.467 279.4 85.5388 280.016 84.7554C280.633 83.9549 281.434 83.3589 282.418 82.9672ZM289.385 79.3651C289.475 78.5306 289.288 77.8834 288.824 77.4236C288.377 76.9637 287.716 76.7338 286.843 76.7338C285.986 76.7338 285.276 76.9637 284.713 77.4236C284.166 77.8834 283.847 78.5391 283.755 79.3907C283.672 80.157 283.863 80.7702 284.327 81.23C284.809 81.6898 285.461 81.9197 286.283 81.9197C287.105 81.9197 287.807 81.6898 288.387 81.23C288.97 80.7531 289.302 80.1315 289.385 79.3651ZM286.002 84.5255C285.025 84.5255 284.202 84.7724 283.532 85.2663C282.879 85.7602 282.503 86.467 282.404 87.3867C282.312 88.2382 282.528 88.9365 283.051 89.4815C283.594 90.0095 284.371 90.2734 285.381 90.2734C286.392 90.2734 287.218 90.0009 287.859 89.4559C288.5 88.911 288.866 88.2212 288.956 87.3867C289.053 86.484 288.829 85.7858 288.283 85.2919C287.738 84.7809 286.978 84.5255 286.002 84.5255ZM306.685 77.2958H298.359L297.888 81.6643C298.295 81.2215 298.848 80.8638 299.545 80.5913C300.245 80.3018 300.971 80.157 301.725 80.157C303.095 80.157 304.185 80.4551 304.994 81.0512C305.804 81.6473 306.355 82.4136 306.648 83.3503C306.942 84.27 307.033 85.2578 306.919 86.3137C306.708 88.2723 305.972 89.8477 304.713 91.0398C303.471 92.232 301.813 92.8281 299.741 92.8281C297.788 92.8281 296.282 92.3427 295.221 91.3719C294.161 90.4012 293.639 89.1324 293.654 87.5655H297.148C297.229 88.2467 297.513 88.7917 298 89.2005C298.504 89.6092 299.175 89.8136 300.015 89.8136C301.025 89.8136 301.822 89.4985 302.404 88.8684C302.985 88.2382 303.332 87.4037 303.445 86.3648C303.559 85.3089 303.379 84.5085 302.907 83.9635C302.454 83.4014 301.722 83.1204 300.711 83.1204C299.992 83.1204 299.373 83.2993 298.855 83.6569C298.337 84.0146 297.943 84.4914 297.673 85.0875H294.23L295.41 74.1536H307.024L306.685 77.2958Z",
    fill: "#85BAF1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: -0.446347,
    y: -0.497113,
    width: 217.469,
    height: 56.3858,
    rx: 9.35815,
    transform: "matrix(1 0 -0.107305 0.994226 74.8899 83.9971)",
    fill: "white",
    stroke: "#E55A9E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.543 95.6487C114.33 95.6398 115.884 96.579 116.62 98.1126L121.822 108.963C122.558 110.496 122.363 112.391 121.311 113.934L113.869 124.847C112.817 126.389 111.068 127.345 109.281 127.354L96.6364 127.417C94.8492 127.426 93.2951 126.487 92.5597 124.953L87.3568 114.103C86.6213 112.57 86.8163 110.675 87.8681 109.132L95.3099 98.2191C96.3618 96.6766 98.1108 95.7208 99.898 95.7119L112.543 95.6487Z",
    fill: "#E55A9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.402 105.366L97.7954 117.583",
    stroke: "white",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.084 117.583L99.114 105.366",
    stroke: "white",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.455 107.258L261.063 115.691",
    stroke: "#62B3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.545 115.691L261.974 107.258",
    stroke: "#62B3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 60.0433,
    height: 8.12314,
    rx: 4,
    transform: "matrix(1 0 -0.107305 0.994226 144.577 99.0892)",
    fill: "#B5DBFF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 91.6737,
    height: 4.83212,
    rx: 2.41606,
    transform: "matrix(1 0 -0.107305 0.994226 143.223 111.638)",
    fill: "#B5DBFF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 91.6737,
    height: 4.83212,
    rx: 2.41606,
    transform: "matrix(1 0 -0.107305 0.994226 142.276 120.409)",
    fill: "#B5DBFF"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 310.5,
    y: 0.5,
    width: 115.724,
    height: 121.405,
    rx: 9.35815,
    fill: "white",
    stroke: "#B5DBFF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 320.968,
    y: 95.8454,
    width: 95.1101,
    height: 16.551,
    rx: 4.42907,
    fill: "#B5DBFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M372.259 19.2819L404.186 74.5808C405.918 77.5808 403.753 81.3308 400.289 81.3308H336.435C332.971 81.3308 330.806 77.5808 332.538 74.5808L364.465 19.2819C366.197 16.2819 370.527 16.2819 372.259 19.2819Z",
    fill: "#E55A9E",
    stroke: "#E55A9E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M370.578 59.6688H366.128L365.498 40.9623H371.208L370.578 59.6688ZM368.353 62.5981C369.255 62.5981 369.978 62.8638 370.522 63.3953C371.078 63.9268 371.356 64.6065 371.356 65.4347C371.356 66.2504 371.078 66.924 370.522 67.4555C369.978 67.9869 369.255 68.2527 368.353 68.2527C367.463 68.2527 366.74 67.9869 366.184 67.4555C365.64 66.924 365.368 66.2504 365.368 65.4347C365.368 64.6189 365.64 63.9453 366.184 63.4138C366.74 62.87 367.463 62.5981 368.353 62.5981Z",
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 9.55011,
    height: 51.5282,
    transform: "matrix(-1 0 0 1 408.045 418.342)",
    fill: "url(#paint0_linear_7316_186954)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 21.5099,
    height: 37.3646,
    transform: "matrix(-1 0 0 1 413.753 452.132)",
    fill: "url(#paint1_linear_7316_186954)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M458.885 480.036C458.885 478.305 457.481 476.902 455.75 476.902H409.993V489.496H455.75C457.481 489.496 458.885 488.093 458.885 486.362V480.036Z",
    fill: "url(#paint2_linear_7316_186954)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M344.841 480.036C344.841 478.305 346.244 476.902 347.975 476.902H393.733V489.496H347.975C346.244 489.496 344.841 488.093 344.841 486.362V480.036Z",
    fill: "url(#paint3_linear_7316_186954)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M432.668 480.036C432.668 478.305 431.264 476.902 429.533 476.902H401.863V489.496H429.533C431.264 489.496 432.668 488.093 432.668 486.362V480.036Z",
    fill: "url(#paint4_linear_7316_186954)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M371.058 480.036C371.058 478.305 372.461 476.902 374.192 476.902H401.863V489.496H374.192C372.461 489.496 371.058 488.093 371.058 486.362V480.036Z",
    fill: "url(#paint5_linear_7316_186954)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.11278,
    cy: 8.11278,
    r: 8.11278,
    transform: "matrix(-1 0 0 1 460.593 491.867)",
    fill: "#16171A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.761,
    cy: 499.98,
    r: 8.11278,
    fill: "#16171A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.11278,
    cy: 8.11278,
    r: 8.11278,
    transform: "matrix(-1 0 0 1 431.619 491.867)",
    fill: "#16171A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.736,
    cy: 499.98,
    r: 8.11278,
    fill: "#16171A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M452.481 489.496C458.271 489.496 462.965 494.19 462.965 499.98H441.997C441.997 494.19 446.691 489.496 452.481 489.496Z",
    fill: "#6C8B6E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M351.761 489.496C345.971 489.496 341.277 494.19 341.277 499.98H362.245C362.245 494.19 357.551 489.496 351.761 489.496Z",
    fill: "#6C8B6E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M423.506 489.496C429.296 489.496 433.99 494.19 433.99 499.98H413.022C413.022 494.19 417.716 489.496 423.506 489.496Z",
    fill: "#6C8B6E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M380.735 489.496C374.945 489.496 370.252 494.19 370.252 499.98H391.219C391.219 494.19 386.525 489.496 380.735 489.496Z",
    fill: "#6C8B6E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M447.133 357.798L438.345 411.527C437.416 417.211 432.505 421.383 426.746 421.383H394.7",
    stroke: "url(#paint6_linear_7316_186954)",
    strokeWidth: 6.26833
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M444.858 431.997H431.657L418.348 424.073",
    stroke: "url(#paint7_linear_7316_186954)",
    strokeWidth: 2.35062
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M458.885 357.798L450.096 411.527C449.167 417.211 444.256 421.383 438.497 421.383H406.451",
    stroke: "url(#paint8_linear_7316_186954)",
    strokeWidth: 6.26833
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M455.586 283.873L435.217 283.873C427.66 283.873 421.18 289.265 419.807 296.696L410.306 348.09C408.982 355.255 412.77 362.387 419.448 365.301L435.116 372.14H444.881L469.103 364.467C476.589 362.095 481.165 354.549 479.805 346.815L471.02 296.831C469.703 289.338 463.194 283.873 455.586 283.873Z",
    fill: "#506D51"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M425.661 417.034H381.262V423.262C381.262 426.724 384.068 429.53 387.53 429.53H419.393C422.854 429.53 425.661 426.724 425.661 423.262V417.034Z",
    fill: "url(#paint9_linear_7316_186954)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M446.036 283.873L425.666 283.873C418.11 283.873 411.63 289.265 410.257 296.696L401.001 346.766C399.568 354.518 404.118 362.128 411.625 364.536L435.331 372.14L459.553 364.467C467.039 362.095 471.614 354.549 470.255 346.815L461.47 296.831C460.153 289.338 453.644 283.873 446.036 283.873Z",
    fill: "#6C8B6E"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 112.603,
    height: 20.6791,
    rx: 5.48479,
    transform: "matrix(-1 0 0 1 459.296 396.913)",
    fill: "#6C8B6E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 47.2099,
    height: 20.6791,
    rx: 5.48479,
    transform: "matrix(-1 0 0 1 382.968 396.913)",
    fill: "#506D51"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.37206,
    cy: 2.37206,
    r: 2.37206,
    transform: "matrix(-1 0 0 1 448.427 325.336)",
    fill: "#506D51"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.37206,
    cy: 2.37206,
    r: 2.37206,
    transform: "matrix(-1 0 0 1 425.661 325.336)",
    fill: "#506D51"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7096,
    height: 4.92032,
    rx: 2.46016,
    transform: "matrix(-1 0 0 1 458.885 429.53)",
    fill: "url(#paint10_linear_7316_186954)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M300.258 303.44L292.681 305.642L291.051 310.194L292.132 312.506C292.32 312.913 292.728 313.172 293.182 313.172C294.028 313.172 294.624 312.334 294.35 311.534L293.887 310.194L295.329 307.507L301.613 306.841L300.258 303.44Z",
    fill: "url(#paint11_linear_7316_186954)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M300.257 303.44C300.634 305.619 301.01 307.797 301.386 309.967C305.28 311.895 312.778 314.786 320.12 312.036C320.724 311.809 321.327 311.542 321.946 311.229H334.616V302.453H321.476L300.257 303.44Z",
    fill: "url(#paint12_linear_7316_186954)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M303.666 305.384L294.029 303.636L287.885 306.292L285.793 308.674C285.472 309.043 285.574 309.615 286.005 309.842C287.126 310.445 288.505 310.249 289.421 309.364L290.283 308.533L294.804 307.248L301.394 309.975L303.666 305.384Z",
    fill: "url(#paint13_linear_7316_186954)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M322.016 311.198C320.34 312.146 316.634 313.916 311.807 313.603C309.566 313.454 307.709 312.906 306.361 312.365H302.451L299.247 313.736C297.977 314.285 296.497 313.838 295.736 312.686C295.525 312.357 295.611 311.918 295.932 311.707L300.634 308.526L311.384 306.857C312.974 306.786 316.469 306.88 319.713 309.137C320.677 309.795 321.429 310.524 322.016 311.198Z",
    fill: "url(#paint14_linear_7316_186954)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M311.862 464.152L305.962 485.684L291.811 481.853L296.826 459.843L311.862 464.152Z",
    fill: "url(#paint15_linear_7316_186954)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M268.806 483.482L267.239 487.612C266.91 488.293 267.004 488.944 267.67 489.296L284.265 495.251L304.786 502.773L308.007 491.365C308.704 488.881 308.391 486.225 307.129 483.968L306.659 483.13L306.495 483.741C306.212 484.783 305.139 485.402 304.097 485.12L299.067 483.764C299.764 480.231 297.492 476.799 293.966 476.07L292.751 475.819L283.553 481.045L277.652 479.188C274.064 478.381 270.389 480.16 268.806 483.482Z",
    fill: "url(#paint16_linear_7316_186954)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M268.806 483.482L266.996 488.254C266.816 488.638 266.965 489.1 267.341 489.304L304.536 502.703C304.904 502.836 305.304 502.632 305.413 502.256L305.946 500.383C306.04 500.039 305.852 499.686 305.523 499.568L279.243 490.432L282.722 480.795L277.66 479.196C274.064 478.381 270.389 480.16 268.806 483.482Z",
    fill: "url(#paint17_linear_7316_186954)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M286.569 485.104C286.945 484.861 287.055 484.368 286.82 483.992L284.391 480.16C284.156 479.784 283.654 479.674 283.278 479.909C282.902 480.152 282.792 480.646 283.027 481.022L285.456 484.854C285.699 485.23 286.193 485.347 286.569 485.104Z",
    fill: "url(#paint18_linear_7316_186954)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M288.865 483.984C289.241 483.741 289.351 483.247 289.116 482.871L286.687 479.04C286.452 478.664 285.95 478.554 285.574 478.789C285.198 479.032 285.088 479.525 285.323 479.902L287.752 483.733C287.987 484.117 288.489 484.227 288.865 483.984Z",
    fill: "url(#paint19_linear_7316_186954)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M290.824 482.926C291.2 482.683 291.31 482.19 291.074 481.813L288.645 477.982C288.41 477.606 287.909 477.496 287.533 477.731C287.157 477.974 287.047 478.468 287.282 478.844L289.711 482.675C289.946 483.059 290.448 483.169 290.824 482.926Z",
    fill: "url(#paint20_linear_7316_186954)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M292.783 481.876C293.159 481.633 293.268 481.14 293.033 480.763L290.604 476.932C290.369 476.556 289.868 476.446 289.492 476.681C289.116 476.924 289.006 477.418 289.241 477.794L291.67 481.625C291.905 482.001 292.406 482.111 292.783 481.876Z",
    fill: "url(#paint21_linear_7316_186954)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M294.734 480.818C295.11 480.575 295.219 480.082 294.984 479.706L292.555 475.874C292.32 475.498 291.819 475.388 291.443 475.623C291.066 475.866 290.957 476.36 291.192 476.736L293.621 480.568C293.864 480.944 294.357 481.053 294.734 480.818Z",
    fill: "url(#paint22_linear_7316_186954)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M374.161 463.251L379.058 485.034L364.766 488.293L358.859 466.511L374.161 463.251Z",
    fill: "url(#paint23_linear_7316_186954)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M357.135 297.007C365.699 304.819 374.271 312.631 382.835 320.443C380.657 307.899 378.635 294.853 376.841 281.337C374.937 267.006 373.417 253.121 372.218 239.731C370.619 243.758 369.037 247.997 367.509 252.463C365.621 257.979 363.959 263.464 363.113 266.496C359.642 278.931 357.566 293.834 357.135 297.007Z",
    fill: "url(#paint24_linear_7316_186954)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M325.135 316.142C325.119 318.351 327.744 320.153 331.881 321.086C342.2 323.013 354.541 324.494 368.488 324.565C378.329 324.612 387.293 323.938 395.215 322.935C395.105 322.7 395.011 322.457 394.901 322.222C394.212 321.47 380.085 306.198 371.998 299.593C370.29 298.198 368.214 296.671 365.385 295.307C363.92 294.602 360.966 293.207 357.103 292.698C351.305 291.938 346.502 293.56 343.854 294.72C338.902 294.774 335.909 294.814 330.957 294.868C327.783 294.782 324.234 295.879 324.242 298.528L317.354 298.606L317.495 315.758L325.135 316.142Z",
    fill: "url(#paint25_linear_7316_186954)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M366.945 219.155C372.806 222.14 384.849 227.304 400.872 227.241C416.574 227.178 428.382 222.132 434.227 219.155C434.227 219.155 434.784 185.51 425.538 169.768C416.292 154.027 405.221 153.314 399.571 153.314C394.329 153.314 383.258 155.046 376.904 167.465C370.557 179.884 366.945 219.155 366.945 219.155Z",
    fill: "url(#paint26_linear_7316_186954)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M436.609 234.951C436.609 234.951 432.503 230.532 423.195 230.156C413.887 229.78 383.799 230.344 380.453 231.645C377.099 232.945 372.86 236.032 371.513 242.073C370.173 248.115 367.791 258.269 367.791 263.112C367.791 267.954 369.037 274.771 369.037 274.771L431.179 291.233L436.609 258.974V234.951Z",
    fill: "url(#paint27_linear_7316_186954)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M392.982 231.974L392.88 232.06C388.539 235.484 385.812 240.553 385.35 246.062L383.313 270.312H373.856L375.36 245.56C375.681 240.303 378.063 235.382 381.997 231.872H381.213L392.982 231.974Z",
    fill: "url(#paint28_linear_7316_186954)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M377.695 233.102C378.823 232.671 380.1 233.149 380.664 234.215L391.187 252.581H397.628V223.652C387.332 225 385.256 227.954 385.256 227.954C379.332 227.21 377.695 233.102 377.695 233.102Z",
    fill: "url(#paint29_linear_7316_186954)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M368.974 328.388L368.339 342.343L319.65 357.411C313.758 359.291 309.025 363.718 306.753 369.469L291.842 463.494L315.192 467.553L335.399 387.389L405.659 372.353V328.396H368.974V328.388Z",
    fill: "url(#paint30_linear_7316_186954)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M389.393 336.71V357.403H397.628V336.772L389.393 336.71Z",
    fill: "url(#paint31_linear_7316_186954)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M440.817 336.553L444.723 360.674C447.809 379.734 433.093 397.025 413.784 397.025H362.818L378.22 464.278L355.356 470.671L330.731 399.164C325.92 381.37 332.62 369.844 349.348 365.425L397.62 353.446L397.487 324.126L440.817 336.553Z",
    fill: "url(#paint32_linear_7316_186954)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M372.523 293.215C372.523 293.215 369.225 310.704 368.512 336.772L440.817 336.553C437.44 317.638 430.153 299.726 430.153 299.726L433.358 278.265L421.495 270.312H373.714L368.974 274.669L372.523 293.215Z",
    fill: "url(#paint33_linear_7316_186954)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M385.131 324.118H397.487C397.706 324.118 397.761 324.118 397.761 324.118H410.118C421.824 324.118 421.072 313.47 421.072 313.47V295.096H374.161V313.47C374.169 313.47 373.432 324.118 385.131 324.118Z",
    fill: "url(#paint34_linear_7316_186954)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M431.172 231.974L431.07 232.06C426.729 235.484 424.002 240.553 423.54 246.062L421.503 270.312H411.262L412.766 245.56C413.087 240.303 415.469 235.382 419.403 231.872L427.411 230.54L431.172 231.974Z",
    fill: "url(#paint35_linear_7316_186954)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M397.62 223.652V252.581H404.923L421.738 234.473C423.281 232.804 425.436 231.833 427.708 231.77L430.474 231.692C429.91 226.379 423.54 226.928 423.54 226.928C423.54 226.928 421.307 223.206 404.923 223.206C402.141 223.206 399.72 223.37 397.62 223.652Z",
    fill: "url(#paint36_linear_7316_186954)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M388.202 236.338L397.62 252.581L413.706 232.875C413.996 232.522 414.224 232.138 414.388 231.754V231.746C415.587 228.949 413.706 225.549 410.415 225.345L399.289 224.647L393.554 225.423C390.044 225.893 387.622 228.683 387.254 231.84V231.848C387.082 233.337 387.364 234.896 388.202 236.338Z",
    fill: "url(#paint37_linear_7316_186954)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M393.178 219.625H406.067V234.136H393.178V219.625Z",
    fill: "url(#paint38_linear_7316_186954)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M399.626 240.577C396.069 240.577 393.185 237.693 393.185 234.136C393.185 230.579 396.069 227.695 399.626 227.695C403.183 227.695 406.067 230.579 406.067 234.136C406.067 237.693 403.183 240.577 399.626 240.577Z",
    fill: "url(#paint39_linear_7316_186954)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M421.463 205.004C416.933 205.004 413.26 201.331 413.26 196.8C413.26 192.27 416.933 188.597 421.463 188.597C425.994 188.597 429.667 192.27 429.667 196.8C429.667 201.331 425.994 205.004 421.463 205.004Z",
    fill: "url(#paint40_linear_7316_186954)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M427.066 197.404C427.403 197.404 427.677 197.13 427.677 196.793C427.677 193.369 424.888 190.579 421.464 190.579C421.127 190.579 420.852 190.853 420.852 191.19C420.852 191.527 421.127 191.801 421.464 191.801C424.222 191.801 426.463 194.042 426.463 196.8C426.463 197.137 426.737 197.404 427.066 197.404Z",
    fill: "url(#paint41_linear_7316_186954)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M377.852 188.088V200.444C377.852 205.012 379.262 209.251 381.667 212.753C385.585 218.473 392.167 222.219 399.626 222.219C411.646 222.219 421.393 212.471 421.393 200.444V188.088C421.393 176.06 411.646 166.313 399.626 166.313C393.616 166.313 388.171 168.75 384.23 172.691C380.288 176.632 377.852 182.078 377.852 188.088Z",
    fill: "url(#paint42_linear_7316_186954)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.143 181.919C382.143 181.919 383.93 180.94 386.68 182.031Z",
    fill: "#D8D8D8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M382.143 181.919C382.143 181.919 383.93 180.94 386.68 182.031",
    stroke: "#251D26",
    strokeWidth: 3.13416,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.525 181.919C405.525 181.919 407.312 180.94 410.063 182.031Z",
    fill: "#D8D8D8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M405.525 181.919C405.525 181.919 407.312 180.94 410.063 182.031",
    stroke: "#251D26",
    strokeWidth: 3.13416,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M392.825 198.062C392.825 198.062 396.233 205.043 392.825 205.043C389.417 205.043 392.825 198.062 392.825 198.062Z",
    fill: "url(#paint43_linear_7316_186954)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M422.161 190.822C422.161 190.822 427.779 176.977 412.523 166.352C400.394 157.905 385.123 164.08 380.257 173.498C377.021 179.751 377.217 187.28 377.217 187.28L403.395 187.296C407.211 187.296 410.361 184.326 410.588 180.526L411.121 171.555L412.57 182.556C413.197 187.288 417.232 190.83 422.004 190.83H422.161V190.822Z",
    fill: "url(#paint44_linear_7316_186954)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M405.871 194.904C406.49 194.904 406.984 194.403 406.984 193.792V191.668C406.984 191.049 406.482 190.556 405.871 190.556C405.252 190.556 404.758 191.057 404.758 191.668V193.792C404.758 194.403 405.26 194.904 405.871 194.904Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M384.136 194.904C384.755 194.904 385.248 194.403 385.248 193.792V191.668C385.248 191.049 384.747 190.556 384.136 190.556C383.517 190.556 383.023 191.057 383.023 191.668V193.792C383.023 194.403 383.524 194.904 384.136 194.904Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M398.059 208.415L393.13 208.415C392.966 208.415 392.825 208.548 392.825 208.721C392.825 208.885 392.958 209.026 393.13 209.026L398.059 209.026C399.132 209.026 400.135 209.442 400.895 210.202C401.013 210.319 401.209 210.319 401.326 210.202C401.444 210.084 401.444 209.888 401.326 209.771C400.449 208.893 399.289 208.415 398.059 208.415Z",
    fill: "url(#paint45_linear_7316_186954)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M412.829 213.482C409.198 213.482 406.255 210.539 406.255 206.908C406.255 203.277 409.198 200.334 412.829 200.334C416.46 200.334 419.403 203.277 419.403 206.908C419.403 210.539 416.46 213.482 412.829 213.482Z",
    fill: "url(#paint46_linear_7316_186954)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M377.852 200.389V200.444C377.852 205.012 379.262 209.251 381.667 212.753C383.799 211.664 385.248 209.455 385.248 206.9C385.248 203.273 382.31 200.334 378.674 200.334C378.392 200.334 378.118 200.35 377.852 200.389Z",
    fill: "url(#paint47_linear_7316_186954)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M429.761 324.314C440.762 325.724 455.265 320.443 449.6 293.709C449.6 293.709 446.505 259.413 444.053 248.154C441.593 236.886 434.157 233.251 434.157 233.251C433.467 236.894 432.511 242.214 431.532 248.663C429.134 264.42 426.956 278.767 427.41 295.997C427.599 303.025 427.52 312.584 429.761 324.314Z",
    fill: "url(#paint48_linear_7316_186954)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M388.202 236.338L397.62 252.581L413.706 232.875C413.996 232.522 414.224 232.138 414.388 231.754L407.94 231.778L391.313 231.833L387.254 231.848C387.082 233.337 387.364 234.896 388.202 236.338Z",
    fill: "url(#paint49_linear_7316_186954)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M387.254 231.848C387.082 233.337 387.364 234.896 388.202 236.338L397.62 252.581L413.706 232.875C413.996 232.522 414.224 232.138 414.388 231.754V231.746L407.94 231.77V231.778C407.932 236.377 404.218 240.185 399.626 240.185C395.027 240.185 391.313 236.424 391.313 231.833L387.254 231.84V231.848Z",
    fill: "url(#paint50_linear_7316_186954)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M319.172 456.756L315.897 471.721L290.017 466.558L291.85 451.796L319.172 456.756Z",
    fill: "url(#paint51_linear_7316_186954)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M345.217 500.532L345.781 504.975C345.812 505.727 346.439 506.252 347.199 506.244L364.398 503.659L386.047 500.665L383.532 489.077C382.984 486.554 381.456 484.352 379.285 482.957L378.471 482.432L378.612 483.051C378.854 484.101 378.196 485.151 377.146 485.394L372.069 486.562C371.027 483.114 367.407 481.155 363.951 482.166L362.76 482.511L357.088 491.451L351 492.579C347.466 493.559 345.06 496.857 345.217 500.532Z",
    fill: "url(#paint52_linear_7316_186954)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M345.217 500.532L345.758 505.179C345.852 505.751 346.142 506.385 346.957 506.283L364.727 503.98L385.797 500.72C386.181 500.665 386.439 500.297 386.361 499.913L385.953 498.009C385.875 497.664 385.546 497.437 385.193 497.492L364.171 500.955L358.177 501.88L357.103 491.459L351.023 492.587C347.466 493.559 345.06 496.857 345.217 500.532Z",
    fill: "url(#paint53_linear_7316_186954)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M376.88 449.085L380.312 466.166L354.322 472.473L349.534 456.066L376.88 449.085Z",
    fill: "url(#paint54_linear_7316_186954)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M361.672 493.621C361.891 493.237 361.758 492.744 361.366 492.517L357.425 490.268C357.041 490.048 356.547 490.182 356.328 490.573C356.108 490.957 356.242 491.451 356.633 491.678L360.575 493.927C360.958 494.146 361.452 494.013 361.672 493.621Z",
    fill: "url(#paint55_linear_7316_186954)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M363.168 491.561C363.387 491.177 363.254 490.683 362.862 490.456L358.921 488.207C358.537 487.988 358.044 488.121 357.824 488.513C357.605 488.897 357.738 489.39 358.13 489.617L362.071 491.866C362.455 492.086 362.949 491.945 363.168 491.561Z",
    fill: "url(#paint56_linear_7316_186954)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M364.398 489.704C364.618 489.32 364.484 488.826 364.093 488.599L360.151 486.35C359.768 486.131 359.274 486.264 359.054 486.656C358.835 487.04 358.968 487.533 359.36 487.76L363.301 490.009C363.685 490.229 364.179 490.095 364.398 489.704Z",
    fill: "url(#paint57_linear_7316_186954)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M365.628 487.855C365.848 487.471 365.714 486.977 365.323 486.75L361.381 484.501C360.998 484.282 360.504 484.415 360.284 484.807C360.065 485.19 360.198 485.684 360.59 485.911L364.531 488.16C364.923 488.379 365.409 488.246 365.628 487.855Z",
    fill: "url(#paint58_linear_7316_186954)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M366.866 486.005C367.086 485.621 366.953 485.128 366.561 484.901L362.62 482.652C362.236 482.432 361.742 482.566 361.523 482.957C361.303 483.341 361.437 483.835 361.828 484.062L365.769 486.311C366.153 486.523 366.647 486.389 366.866 486.005Z",
    fill: "url(#paint59_linear_7316_186954)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M350.616 304.138L356.492 303.354L357.276 306.097L351.791 306.88L348.657 309.231L347.92 310.892C347.442 311.965 346.244 312.514 345.115 312.192C344.692 312.075 344.449 311.628 344.575 311.213L345.523 308.055L350.616 304.138Z",
    fill: "url(#paint60_linear_7316_186954)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M348.265 305.705L356.884 306.097L357.276 310.014L349.832 309.231L346.698 310.798L346.056 312.937C345.758 313.932 344.723 314.52 343.713 314.269C342.992 314.089 342.569 313.337 342.788 312.624L343.956 308.839L348.265 305.705Z",
    fill: "url(#paint61_linear_7316_186954)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M357.48 309.152L349.37 308.659L342.78 310.492L341.237 312.2C340.626 312.882 340.72 313.932 341.448 314.488C342.052 314.951 342.898 314.911 343.454 314.402L344.575 313.376L350.678 312.232L357.354 314.394L357.48 309.152Z",
    fill: "url(#paint62_linear_7316_186954)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M383.979 302.257C383.979 302.257 355.693 303.017 355.779 303.519C355.865 304.02 357.284 314.418 357.284 314.418C361.585 314.943 368.277 315.076 375.446 312.177C377.225 311.456 378.815 310.633 380.226 309.787C384.331 310.022 388.437 310.265 392.543 310.5L392.849 302.531L383.979 302.257Z",
    fill: "url(#paint63_linear_7316_186954)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M378.032 298.614L378.173 315.765L385.797 316.142C385.781 318.359 388.328 320.6 392.551 321.086C425.225 324.847 433.601 324.518 433.601 324.518C439.673 315.115 449.608 293.717 449.608 293.717C449.608 293.717 439.885 292.439 425.154 292.51C416.151 292.549 407.501 293.599 404.523 294.735C399.571 294.79 396.578 294.829 391.626 294.884C388.461 294.79 384.904 295.887 384.911 298.535L378.032 298.614Z",
    fill: "url(#paint64_linear_7316_186954)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M441.906 300.142C442.094 300.142 442.29 300.071 442.439 299.93C442.752 299.632 442.776 299.139 442.478 298.825L441.232 297.485C438.067 294.085 433.585 292.071 428.938 291.954C428.93 291.954 428.923 291.954 428.915 291.954C428.492 291.954 428.139 292.291 428.131 292.714C428.124 293.145 428.46 293.505 428.891 293.513C433.115 293.623 437.197 295.456 440.08 298.551L441.326 299.891C441.491 300.055 441.694 300.142 441.906 300.142Z",
    fill: "url(#paint65_linear_7316_186954)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M422.875 504.709L402.265 336.114H394.318L416.89 505.474C417.09 506.973 418.368 508.092 419.88 508.092C421.692 508.092 423.095 506.507 422.875 504.709Z",
    fill: "#F77E7E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M403.074 342.728L402.25 335.928L394.209 335.412L395.468 344.748L403.074 342.728Z",
    fill: "#D74C4C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M305.969 504.71L326.58 336.115H334.527L311.954 505.475C311.755 506.973 310.476 508.093 308.964 508.093C307.153 508.093 305.75 506.508 305.969 504.71Z",
    fill: "#F77E7E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M325.76 342.728L326.584 335.928L334.625 335.412L333.365 344.748L325.76 342.728Z",
    fill: "#D74C4C"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M193.588 504.709L172.978 336.114H165.031L187.603 505.474C187.803 506.973 189.082 508.092 190.594 508.092C192.405 508.092 193.808 506.507 193.588 504.709Z",
    fill: "#F77E7E"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M173.788 342.728L172.963 335.928L164.922 335.412L166.182 344.748L173.788 342.728Z",
    fill: "#D74C4C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6827 504.71L97.293 336.115H105.24L82.6676 505.475C82.4679 506.973 81.1893 508.093 79.6772 508.093C77.8659 508.093 76.4629 506.508 76.6827 504.71Z",
    fill: "#F77E7E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M96.473 342.728L97.2974 335.928L105.339 335.412L104.079 344.748L96.473 342.728Z",
    fill: "#D74C4C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M313.987 325.786H76.6885C75.3803 325.786 74.3198 326.847 74.3198 328.155V333.746C74.3198 335.054 75.3803 336.115 76.6885 336.115H313.987V325.786Z",
    fill: "#D7DCFE"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M420.367 328.155C420.367 326.847 419.307 325.786 417.999 325.786H309.027C307.719 325.786 306.659 326.847 306.659 328.155V333.746C306.659 335.054 307.719 336.115 309.027 336.115H417.999C419.307 336.115 420.367 335.054 420.367 333.746V328.155Z",
    fill: "#B5BFFF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M252.934 275.616L269.553 320.466C269.984 321.712 271.183 322.527 272.483 322.527H307.398C309.028 322.527 310.219 320.897 309.623 319.322L293.114 274.692C292.683 273.446 291.484 272.631 290.184 272.631H254.995C253.475 272.631 252.441 274.151 252.934 275.616Z",
    fill: "url(#paint66_linear_7316_186954)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M304.013 324.321C304.013 323.506 304.663 322.856 305.478 322.856H345.227C346.042 322.856 346.693 323.506 346.693 324.321C346.693 325.136 346.042 325.786 345.227 325.786H305.478C304.663 325.786 304.013 325.136 304.013 324.321Z",
    fill: "#859EA8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M268.605 324.321C268.605 323.506 269.255 322.856 270.07 322.856H309.419C310.234 322.856 310.885 323.506 310.885 324.321C310.885 325.136 310.234 325.786 309.419 325.786H270.07C269.31 325.786 268.66 325.136 268.605 324.321Z",
    fill: "#41545B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M251.069 275.616L267.688 320.466C268.119 321.712 269.318 322.527 270.618 322.527H305.533C307.163 322.527 308.354 320.897 307.758 319.322L291.249 274.692C290.818 273.446 289.619 272.631 288.319 272.631H253.13C251.61 272.631 250.583 274.151 251.069 275.616Z",
    fill: "url(#paint67_linear_7316_186954)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M166.865 302.858C166.865 301.56 167.917 300.508 169.215 300.508H185.819C187.117 300.508 188.17 301.56 188.17 302.858V317.951C188.17 322.278 184.662 325.786 180.334 325.786H174.7C170.373 325.786 166.865 322.278 166.865 317.951V302.858Z",
    fill: "#506D51"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M167.357 306.387H187.681",
    stroke: "#89A68A",
    strokeWidth: 0.783541,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M185.816 256.723V256.723C181.233 261.561 178.673 267.977 178.673 274.642V300.508",
    stroke: "#3A6B3B",
    strokeWidth: 0.651191
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M171.222 268.798V268.798C174.544 272.304 176.396 276.951 176.396 281.781V300.508",
    stroke: "#3A6B3B",
    strokeWidth: 0.651191
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 8.8923,
    height: 9.12067,
    rx: 1.30238,
    transform: "matrix(-1 0 0 1 187.729 264.238)",
    fill: "#E590BE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M182.472 268.011L179.875 265.27",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M184.068 269.568L186.664 272.309",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M184.068 268.011L186.664 265.27",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M182.472 269.568L179.875 272.309",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M183.352 270.063L183.259 270.225L183.158 270.045C182.726 269.274 182.715 268.336 183.129 267.555L183.259 267.308L183.382 267.536C183.809 268.327 183.797 269.283 183.352 270.063Z",
    fill: "#E53883"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M181.97 268.852L181.808 268.759L181.988 268.658C182.76 268.226 183.697 268.215 184.479 268.629L184.725 268.759L184.498 268.882C183.707 269.309 182.751 269.297 181.97 268.852Z",
    fill: "#E53883"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 8.8923,
    height: 9.12067,
    rx: 1.30238,
    transform: "matrix(-1 0 0 1 173.732 264.402)",
    fill: "#E590BE"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M168.475 268.175L165.879 265.434",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M170.071 269.732L172.668 272.473",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M170.071 268.175L172.668 265.434",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M168.475 269.732L165.879 272.473",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M169.355 270.228L169.262 270.39L169.161 270.209C168.73 269.438 168.719 268.5 169.132 267.719L169.262 267.472L169.385 267.7C169.812 268.491 169.8 269.447 169.355 270.228Z",
    fill: "#E53883"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M167.974 269.016L167.812 268.923L167.992 268.822C168.763 268.39 169.701 268.379 170.482 268.793L170.729 268.923L170.501 269.046C169.71 269.473 168.754 269.461 167.974 269.016Z",
    fill: "#E53883"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 8.8923,
    height: 9.12067,
    rx: 1.30238,
    transform: "matrix(-1 0 0 1 191.137 252.762)",
    fill: "#E590BE"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M185.88 256.536L183.283 253.795",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M187.476 258.093L190.072 260.834",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M187.476 256.536L190.072 253.795",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M185.88 258.093L183.283 260.834",
    stroke: "#E55A9E",
    strokeWidth: 2.08381,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M186.759 258.588L186.667 258.75L186.566 258.57C186.134 257.799 186.123 256.861 186.537 256.079L186.667 255.833L186.79 256.06C187.216 256.852 187.205 257.807 186.759 258.588Z",
    fill: "#E53883"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M185.378 257.376L185.216 257.284L185.396 257.183C186.168 256.751 187.106 256.74 187.887 257.154L188.133 257.284L187.906 257.407C187.115 257.834 186.159 257.822 185.378 257.376Z",
    fill: "#E53883"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M169.378 279.351L174.962 290.271C175.548 291.417 174.292 292.628 173.167 292.001L162.513 286.054C161.196 285.319 160.276 284.021 160.012 282.536C159.39 279.048 162.488 276.006 165.954 276.734C167.432 277.045 168.69 278.006 169.378 279.351Z",
    fill: "url(#paint68_linear_7316_186954)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M185.553 279.351L179.969 290.271C179.383 291.417 180.639 292.628 181.763 292.001L192.418 286.054C193.735 285.319 194.654 284.021 194.919 282.536C195.541 279.048 192.443 276.006 188.976 276.734C187.499 277.045 186.241 278.006 185.553 279.351Z",
    fill: "url(#paint69_linear_7316_186954)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M176.209 293.372L163.309 279.495",
    stroke: "#3A6B3B",
    strokeWidth: 0.651191,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M178.722 293.372L191.621 279.495",
    stroke: "#3A6B3B",
    strokeWidth: 0.651191,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7316_186954",
    x1: 6.16955,
    y1: -3.94796,
    x2: -18.9808,
    y2: 10.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26586C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41545B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7316_186954",
    x1: 24.6928,
    y1: -4.21204,
    x2: -26.0946,
    y2: 21.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7316_186954",
    x1: 403.653,
    y1: 483.199,
    x2: 477.877,
    y2: 483.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7316_186954",
    x1: 400.968,
    y1: 475.482,
    x2: 389.263,
    y2: 514.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7316_186954",
    x1: 429.14,
    y1: 482.278,
    x2: 392.631,
    y2: 482.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7316_186954",
    x1: 404.514,
    y1: 483.199,
    x2: 381.921,
    y2: 505.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7316_186954",
    x1: 386.941,
    y1: 350.63,
    x2: 489.29,
    y2: 423.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7316_186954",
    x1: 414.425,
    y1: 423.18,
    x2: 422.736,
    y2: 447.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7316_186954",
    x1: 398.693,
    y1: 350.63,
    x2: 501.041,
    y2: 423.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7316_186954",
    x1: 374.692,
    y1: 415.626,
    x2: 387.184,
    y2: 454.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7316_186954",
    x1: 12.0868,
    y1: -0.376983,
    x2: 11.6004,
    y2: 5.21291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26586C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41545B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7316_186954",
    x1: 302.038,
    y1: 301.628,
    x2: 291.472,
    y2: 311.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1975,
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#FC9B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8156,
    stopColor: "#FA7C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7316_186954",
    x1: 334.206,
    y1: 307.741,
    x2: 311.976,
    y2: 307.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7316_186954",
    x1: 278.945,
    y1: 307.704,
    x2: 293.514,
    y2: 307.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2298,
    stopColor: "#FA7C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6377,
    stopColor: "#FC9B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7316_186954",
    x1: 346.609,
    y1: 305.272,
    x2: 287.122,
    y2: 314.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1496,
    stopColor: "#FA7C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#FC9B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#FFBB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7316_186954",
    x1: 299.209,
    y1: 483.358,
    x2: 302.7,
    y2: 468.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4001,
    stopColor: "#FFB989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#FEB185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7351,
    stopColor: "#FDA47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8578,
    stopColor: "#FC9274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9652,
    stopColor: "#FA7A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7316_186954",
    x1: 320.336,
    y1: 501.946,
    x2: 284.381,
    y2: 484.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#827250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7316_186954",
    x1: 303.459,
    y1: 499.381,
    x2: 273.795,
    y2: 484.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7316_186954",
    x1: 283.241,
    y1: 479.999,
    x2: 286.126,
    y2: 484.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7316_186954",
    x1: 285.329,
    y1: 478.577,
    x2: 288.213,
    y2: 482.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7316_186954",
    x1: 287.158,
    y1: 477.331,
    x2: 290.042,
    y2: 481.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7316_186954",
    x1: 288.986,
    y1: 476.085,
    x2: 291.871,
    y2: 480.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7316_186954",
    x1: 290.815,
    y1: 474.839,
    x2: 293.7,
    y2: 479.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7316_186954",
    x1: 372.067,
    y1: 486.996,
    x2: 367.506,
    y2: 468.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4001,
    stopColor: "#FFB989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#FEB185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7351,
    stopColor: "#FDA47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8578,
    stopColor: "#FC9274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9652,
    stopColor: "#FA7A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7316_186954",
    x1: 369.245,
    y1: 257.412,
    x2: 370.362,
    y2: 334.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7316_186954",
    x1: 321.695,
    y1: 308.381,
    x2: 393.75,
    y2: 308.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7316_186954",
    x1: 399.757,
    y1: 164.485,
    x2: 401.247,
    y2: 260.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7316_186954",
    x1: 401.909,
    y1: 241.237,
    x2: 403.305,
    y2: 280.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7316_186954",
    x1: 384.109,
    y1: 270.285,
    x2: 382.714,
    y2: 231.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7316_186954",
    x1: 387.592,
    y1: 226.055,
    x2: 388.142,
    y2: 245.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7316_186954",
    x1: 478.379,
    y1: 344.372,
    x2: 187.347,
    y2: 458.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7316_186954",
    x1: 393.33,
    y1: 339.007,
    x2: 395.285,
    y2: 427.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7316_186954",
    x1: 438.388,
    y1: 305.455,
    x2: 342.548,
    y2: 440.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7316_186954",
    x1: 403.28,
    y1: 270.209,
    x2: 404.993,
    y2: 352.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7316_186954",
    x1: 397.138,
    y1: 285.985,
    x2: 402.723,
    y2: 500.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7316_186954",
    x1: 421.909,
    y1: 270.3,
    x2: 420.476,
    y2: 230.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7316_186954",
    x1: 415.62,
    y1: 224.052,
    x2: 406.947,
    y2: 244.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_7316_186954",
    x1: 395.194,
    y1: 253.362,
    x2: 402.553,
    y2: 225.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7316_186954",
    x1: 399.822,
    y1: 238.502,
    x2: 399.543,
    y2: 222.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3974,
    stopColor: "#FFBB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#FEB390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDA687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8519,
    stopColor: "#FC947B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9586,
    stopColor: "#FA7C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_7316_186954",
    x1: 399.699,
    y1: 238.504,
    x2: 399.42,
    y2: 222.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3974,
    stopColor: "#FFBB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#FEB390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDA687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8519,
    stopColor: "#FC947B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9586,
    stopColor: "#FA7C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7316_186954",
    x1: 421.381,
    y1: 188.367,
    x2: 421.521,
    y2: 203.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3974,
    stopColor: "#FFBB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#FEB390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDA687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8519,
    stopColor: "#FC947B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9586,
    stopColor: "#FA7C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_7316_186954",
    x1: 415.737,
    y1: 187.508,
    x2: 425.652,
    y2: 194.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7316_186954",
    x1: 400.152,
    y1: 219.299,
    x2: 399.175,
    y2: 172.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3974,
    stopColor: "#FFBB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#FEB390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDA687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8519,
    stopColor: "#FC947B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9586,
    stopColor: "#FA7C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7316_186954",
    x1: 392.668,
    y1: 189.454,
    x2: 392.947,
    y2: 214.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7316_186954",
    x1: 399.858,
    y1: 164.483,
    x2: 401.348,
    y2: 260.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7316_186954",
    x1: 381.93,
    y1: 209.347,
    x2: 394.638,
    y2: 209.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7316_186954",
    x1: 404.99,
    y1: 191.796,
    x2: 430.125,
    y2: 240.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_7316_186954",
    x1: 381.219,
    y1: 194.002,
    x2: 382.15,
    y2: 221.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7316_186954",
    x1: 450.449,
    y1: 243.237,
    x2: 418.434,
    y2: 355.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_7316_186954",
    x1: 400.799,
    y1: 222.33,
    x2: 400.799,
    y2: 252.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3974,
    stopColor: "#FFBB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#FEB390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDA687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8519,
    stopColor: "#FC947B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9586,
    stopColor: "#FA7C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7316_186954",
    x1: 401.337,
    y1: 264.055,
    x2: 400.918,
    y2: 239.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#B37637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3493,
    stopColor: "#A87338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5162,
    stopColor: "#956E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6809,
    stopColor: "#7A673B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8424,
    stopColor: "#575E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_7316_186954",
    x1: 304.222,
    y1: 428.501,
    x2: 305.62,
    y2: 552.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7316_186954",
    x1: 399.428,
    y1: 492.679,
    x2: 359.398,
    y2: 493.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#827250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_7316_186954",
    x1: 383.321,
    y1: 498.211,
    x2: 350.097,
    y2: 498.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7316_186954",
    x1: 364.479,
    y1: 421.951,
    x2: 366.083,
    y2: 563.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0201,
    stopColor: "#596DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#6085C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    stopColor: "#6696CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#69A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_7316_186954",
    x1: 356.307,
    y1: 490.715,
    x2: 360.838,
    y2: 493.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7316_186954",
    x1: 357.483,
    y1: 488.48,
    x2: 362.013,
    y2: 490.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_7316_186954",
    x1: 358.512,
    y1: 486.52,
    x2: 363.043,
    y2: 488.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_7316_186954",
    x1: 359.542,
    y1: 484.561,
    x2: 364.072,
    y2: 486.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_7316_186954",
    x1: 360.571,
    y1: 482.602,
    x2: 365.102,
    y2: 484.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#353A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_7316_186954",
    x1: 350.488,
    y1: 307.231,
    x2: 354.956,
    y2: 305.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_7316_186954",
    x1: 340.902,
    y1: 309.62,
    x2: 356.536,
    y2: 310.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_7316_186954",
    x1: 355.36,
    y1: 314.847,
    x2: 329.386,
    y2: 301.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_7316_186954",
    x1: 394.212,
    y1: 307.074,
    x2: 371.434,
    y2: 308.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4542,
    stopColor: "#F97163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_7316_186954",
    x1: 435.546,
    y1: 219.861,
    x2: 396.98,
    y2: 355.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_7316_186954",
    x1: 459.731,
    y1: 305.852,
    x2: 432.64,
    y2: 294.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_7316_186954",
    x1: 272.976,
    y1: 268.808,
    x2: 288.243,
    y2: 321.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26586C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41545B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_7316_186954",
    x1: 246.966,
    y1: 276.811,
    x2: 341.898,
    y2: 337.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#859EA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41545B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_7316_186954",
    x1: 163.658,
    y1: 279.021,
    x2: 173.736,
    y2: 290.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55973E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_7316_186954",
    x1: 191.273,
    y1: 279.021,
    x2: 181.195,
    y2: 290.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55973E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/errorImage.57010c194ac4b642e777240b55ca5df2.svg";
export { ForwardRef as ReactComponent };